import { ca } from '@cian/analytics';

export const trackDecline = () => {
  ca('event', {
    name: 'oldevent',
    category: 'NPSBanner',
    action: 'Click',
    label: 'not_now',
  });
};

export const trackAccept = () => {
  ca('event', {
    name: 'oldevent',
    category: 'NPSBanner',
    action: 'Click',
    label: 'rate_cian',
  });
};

export const trackShow = () => {
  ca('event', {
    name: 'oldevent',
    category: 'NPSBanner',
    action: 'Show',
  });
};
